import { Component, OnInit, Input } from "@angular/core";
import { SearchService } from "../../../services/search.service";
import { Cost } from "../../../models/cost.model";
import { debounceTime, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-search-results-for-employee",
  templateUrl: "./search-results-for-employee.component.html",
})
export class SearchResultsForEmployeeComponent implements OnInit {
  state$: Observable<{ loading: boolean; data: Cost[]; empty: boolean; error: string | null }>;
  searchCtrl = new FormControl();
  advanceIdFromRoute: number;

  @Input() value = "";
  @Input() minLength = 3;
  @Input() placeholder = "Szukaj dokumentów dla pracownika...";

  constructor(
    private searchService: SearchService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((paramsId) => {
      this.advanceIdFromRoute = parseInt(paramsId.advanceId, 10);
    });

    try {
      this.state$ = this.searchCtrl.valueChanges.pipe(
        debounceTime(500),
        switchMap((searchValue) => {
          const phrase = typeof searchValue === "string" ? searchValue.trim() : "";
          return phrase.length >= this.minLength
            ? this.searchService.searchState(phrase)
            : of({ loading: false, data: [], empty: false, error: null });
        }),
        map((state) => ({
          loading: state.loading,
          error: state.error,
          empty: !state.loading && !state.error && state.data.filter((r) => r.advance.id === this.advanceIdFromRoute).length === 0,
          data: state.data.filter((r) => r.advance.id === this.advanceIdFromRoute),
        }))
      );
    } catch (error) {
      console.log(error);
      this.state$ = of({ loading: false, data: [], empty: true, error: (error && error.message) || 'Search failed' });
    }
  }

  onSelectedOption(selectedOption: MatAutocompleteSelectedEvent) {
    const cost = selectedOption.option.value;

    if (cost.isKsef) {
      if (cost.realId) {
        this.router.navigate(['/ksef/my'], { queryParams: { highlightKsefId: cost.realId } });
      } else {
        this.router.navigate(['/ksef/my']);
      }
      return;
    }

    const costId = parseInt(cost.id, 10);
    if (!costId) {
      return;
    }

    if ("delegation" === cost.type.name) {
      this.router.navigate([`/delegation/${costId}`]);
      return;
    }

    if (cost.isKsef) {
      if (cost.realId) {
        this.router.navigate(['/ksef/my'], { queryParams: { highlightKsefId: cost.realId } });
      } else {
        this.router.navigate(['/ksef/my']);
      }
      return;
    }

    this.router.navigate([`/cost/${costId}`]);
  }

  displayFn(cost: Cost): string {
    return cost && cost.name ? cost.name : "";
  }
}
